export const TRAINER_INVITATION_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  EXPIRED: 2,
  CANCELLED: 3,
  REJECTED: 4
} as const;

export const TRAINER_INVITATION_STATUS_STRINGS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected'
} as const;

export type TrainerInvitationStatusString =
  (typeof TRAINER_INVITATION_STATUS_STRINGS)[keyof typeof TRAINER_INVITATION_STATUS_STRINGS];

export type TrainerInvitationStatusNumber =
  (typeof TRAINER_INVITATION_STATUS)[keyof typeof TRAINER_INVITATION_STATUS];
